export default __webpack_public_path__ + "static/media/withholding-tax.3f725c81.svg";